<script lang="ts">
    import { gettext as _ } from 'hydria/services/gettext'
    import { readAsIdna, sreplace } from 'hydria/svelte_helpers'

    import WZone from 'wdom/zone/Zone/Zone.svelte'

    interface Props {
        route: any
    }

    let { route }: Props = $props()

    let idnaOk = $state(false)
    let idna = readAsIdna(route.result.path.params?.idna)

    if (idna != route.result.path.params?.idna) {
        sreplace(`/zone/${idna}`)
    } else {
        idnaOk = true
    }
</script>

{#if idnaOk}
    <WZone {idna} mode="admin" />
{/if}
